<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="secondary">
      <ion-buttons slot="start" v-if="!esModal">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Equipo {{equipo.sn}}</ion-title>
      <ion-buttons slot="end" v-if="esModal">
        <ion-button @click="cerrarModal">
          <i class="icon ion-ios-close-circle-outline"></i>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-progress-bar type="indeterminate" v-if="cargando"></ion-progress-bar>
  </ion-header>
  <ion-content :class="!esModal?'ion-padding':''" id="menucontent">
    <ion-item v-if="modo2=='general'">
      <ion-segment :value="modo" v-on:ionChange="setModo($event.detail.value)">
        <ion-segment-button v-for="m in modos" :key="m" :value="m">{{m}}</ion-segment-button>
      </ion-segment>
    </ion-item>
    <div v-else>
      <ion-item lines="none">
        <ion-label color="medium">
          <h1 class="ion-text-capitalize">{{modo2}}</h1>
        </ion-label>
      </ion-item>
      <TarjetaEquipo :id="id" :link="false" />
    </div>
    <div v-if="modo=='general'">
      <ion-list>
        <ion-item>
          <ion-label>Marca</ion-label>
          <ion-input class="ion-text-right" color="primary" :value="equipo.marca" v-on:ionChange="set('marca',$event.detail.value)"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Modelo</ion-label>
          <ion-input class="ion-text-right" color="primary" :value="equipo.modelo" v-on:ionChange="set('modelo',$event.detail.value)"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Número de serie</ion-label>
          <ion-input class="ion-text-right" color="primary" :value="equipo.sn" v-on:ionChange="set('sn',$event.detail.value)"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label text-wrap>Número de inventario (control de cliente)</ion-label>
          <ion-input class="ion-text-right" color="primary" :value="equipo.alias" v-on:ionChange="set('alias',$event.detail.value)"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Área</ion-label>
          <ion-input class="ion-text-right" color="primary" :value="equipo.area" v-on:ionChange="set('area',$event.detail.value)"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Subárea</ion-label>
          <ion-input class="ion-text-right" color="primary" :value="equipo.subarea" v-on:ionChange="set('subarea',$event.detail.value)"></ion-input>
        </ion-item>
        <ion-item @click="seleccionarTipo">
          <ion-label>Tipo de equipo</ion-label>
          <ion-input readonly class="ion-text-right" :value="equipo.tipo!=''?equipo.tipo:'(Sin asignar)'" />
        </ion-item>
        <ion-item @click="seleccionarCliente">
          <ion-label>Pertenece a cliente</ion-label>
          <ion-input readonly class="ion-text-right" :value="clienteNombre" />
        </ion-item>
        <ion-item>
          <ion-label>Inventariable</ion-label>
          <ion-toggle slot="end" :checked="equipo.inventariable" v-on:ionChange="set('inventariable',$event.detail.checked==true)"></ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label text-wrap>Periodicidad de mantenimiento (meses)</ion-label>
          <ion-input class="ion-text-right" color="primary" type="number" min="0" max="24" :value="equipo.periodicidadMeses" v-on:ionChange="set('periodicidadMeses',parseInt($event.detail.value))" />
        </ion-item>
        <ion-item>
          <ion-label>Fecha de alta</ion-label>
          <ion-input class="ion-text-right" color="primary" type="date" readonly :value="equipo.fecha"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label text-wrap>Nombre de contrato</ion-label>
          <ion-input class="ion-text-right" color="primary" :value="equipo.nombreContrato" v-on:ionChange="set('nombreContrato',$event.detail.value)"></ion-input>
        </ion-item>
        <ion-item lines="none">
          <ion-label>&nbsp;</ion-label>
        </ion-item>
      </ion-list>
    </div>
    <div v-if="modo=='costos' && yo.rol=='administrador'">
      <ion-list>
        <ion-item>
          <ion-label>Costo</ion-label>
          <ion-input type="number" class="ion-text-right" color="primary" :value="equipo.costo" v-on:ionChange="set('costo',$event.detail.value)"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Precio de venta</ion-label>
          <ion-input type="number" class="ion-text-right" color="primary" :value="equipo.precioVenta" v-on:ionChange="set('precioVenta',$event.detail.value)"></ion-input>
        </ion-item>
      </ion-list>
    </div>
    <div v-if="modo=='fotos'">
      <ion-list v-if="equipo.imagenes && equipo.imagenes.length>0">
        <ion-item-sliding v-for="i in equipo.imagenes" :key="i.imagen">
          <ion-item>
            <ion-thumbnail slot="start">
              <ion-img :src="cdn+i.imagen"></ion-img>
            </ion-thumbnail>
            <ion-label>
              <h2>{{i.imagen}}</h2>
              <p>{{i.descripcion}}</p>
            </ion-label>
          </ion-item>
          <ion-item-options slot="end">
            <ion-item-option color="danger">
              <i class="icon ion-ios-trash"></i>
            </ion-item-option>
          </ion-item-options>
        </ion-item-sliding>
      </ion-list>
      <ion-item v-else>
        <ion-label text-wrap color="danger" class="ion-text-center">
          <h2>Esta lista está vacía</h2>
          <p>Clic en la cámara para subir una imagen</p>
        </ion-label>
      </ion-item>
    </div>
    <div v-if="modo=='historial'">
      <ion-list>
        <ion-item v-for="orden in historialServicios" :key="orden._id" @click.stop="irAOrden(orden._id)">
          <ion-badge slot="start">{{orden.folio || orden.nombre}}</ion-badge>
          <ion-label text-wrap>
            <h2>{{orden.fecha | moment('MMM DD YYYY, HH:mm')}}</h2>
            <p v-if="orden.solicitante && orden.solicitante!=''">Solicitante: {{orden.solicitante}}</p>
            <p v-if="equipo.idCliente!=orden.idCliente">{{orden.cliente.nombre}}</p>
            <p>{{orden.diagnostico || orden.fallaReportada}}</p>
          </ion-label>
          <ion-note slot="end" v-if="orden.terminada">
            <span v-if="orden.fechaTerminada && empresa.medirTiemposDeOrdenes">{{orden.fechaTerminada | moment('MMM DD HH:mm')}}</span>&nbsp;<i class="icon ion-ios-checkmark-circle-outline"></i>
          </ion-note>
        </ion-item>
      </ion-list>
    </div>
    <div v-if="modo=='custodia'">
      <ion-card>
        <ion-list>
          <ion-item color="light" lines="none">
            <ion-label>Cambiar custodia del equipo</ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-label>Está en posesión de</ion-label>
            <ion-select :value="formCustodia.tipoCustodia" v-on:ionChange="formCustodia.tipoCustodia=$event.detail.value">
              <ion-select-option v-for="tipo in tiposCustodia" :key="tipo">{{tipo}}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-card>
      <ion-list>
        <ion-item v-for="mov in custodias" :key="mov._id">
          <ion-note slot="start">
            <i class="icon ion-ios-link"></i>
          </ion-note>
          <ion-label text-wrap>
            <h2>{{mov.fecha | moment('MMM DD HH:mm')}}</h2>
            <p>{{mov.tipoCustodia}}</p>
          </ion-label>
          <ion-note slot="end" v-if="mov.autor">
            {{mov.autor.nombre}}
          </ion-note>
        </ion-item>
      </ion-list>
    </div>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed" v-if="['general','costos'].indexOf(modo)>=0">
      <ion-fab-button color="primary" @click="guardar" :disabled="!(yo.rol=='administrador' || yo._id==equipo.idAutor) && !bloquearInterfaz">
        <i class="icon icon-lg ion-ios-save"></i>
      </ion-fab-button>
    </ion-fab>
    <label for="img" v-if="modo=='fotos'">
      <input class="hidden" id="img" name="img" type="file" @change="subirImagen">
      <ion-fab horizontal="end" vertical="bottom" slot="fixed">
        <ion-fab-button color="primary">
          <i class="icon icon-lg ion-ios-camera"></i>
        </ion-fab-button>
      </ion-fab>
    </label>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed" v-if="modo=='custodia'">
      <ion-fab-button color="secondary" @click="guardarCustodia" :disabled="bloquearGuardarCustodia">
        <i class="icon icon-lg ion-ios-link"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<script>
import Api from '@/components/Api/Api'
import TiposEquipos from '@/models/TiposEquipos.vue'
import TiposCustodia from '@/models/TiposCustodia.vue'
import TarjetaEquipo from '@/components/TarjetaEquipo'
import Marcas from '@/models/Marcas'
import ModalSeleccionarTipoEquipo from '@/components/ModalSeleccionarTipoEquipo'
import ModalSeleccionarCliente from '@/components/ModalSeleccionarCliente'
export default {
  name: 'CatalogoEquipo',
  props: {
    id: {
      type: String,
      default: ''
    },
    esModal: {
      type: Boolean,
      default: false
    },
    idClienteEquipoNuevo: {
      type: String,
      default: ''
    },
    modo2: {
      type: String,
      default: 'general'
    }
  },
  components: {
    TarjetaEquipo
  },
  data() {
    return {
      modo: 'general',
      modos: ['general', 'costos', 'fotos'],
      cargando: false,
      yo: Api.fetchLocal('cmms.yo') || {},
      cdn: Api.cdn + '/',
      empresa: {},
      equipo: {
        fecha: new Date().toISOString().substring(0, 10),
        idAutor: (Api.fetchLocal('cmms.yo') || {})._id,
        marca: '',
        modelo: '',
        alias: '', // Numero de inventario
        sn: '',
        idCliente: '',
        periodicidadMeses: 0,
      },
      tiposEquipos: [],
      tiposCustodia: [],
      marcas: [],
      clientes: ['IMSS #2', 'N.S.A.', 'Las Américas'],
      formCustodia: {},
      custodias: [],
      historialServicios: [],
      bloquearGuardarCustodia: false,
      bloquearInterfaz: true,
      modals: {}
    }
  },
  computed: {
    clienteNombre() {
      if (!this.equipo.idCliente || this.equipo.idCliente === '') return '(Sin cliente)'
      let cliente = this.clientes.find(c => c._id === this.equipo.idCliente)
      return cliente ? (cliente.alias || cliente.nombre) : '(Sin cliente)'
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    irAOrden(ordenId) {
      // Navegar a la orden con validación
      if (ordenId && ordenId !== '') {
        this.$router.push('/ordenes/' + ordenId)
      }
    },
    async obtener() {
      if (this.id && this.id.length > 1) {
        this.equipo = await Api.get('equipo', this.id)
        console.log("Equipo", this.equipo)
        if (this.modos.indexOf('custodia') == -1) {
          this.modos.push('historial')
          this.modos.push('custodia')
        }
        if ((this.custodias[0] || []).tipoCustodia == 'Baja' && this.yo.rol != 'administrador')
          this.bloquearGuardarCustodia = true
      } else {
        // Inicializar si viene de un modal
        if (this.idClienteEquipoNuevo && this.idClienteEquipoNuevo != '')
          this.equipo.idCliente = this.idClienteEquipoNuevo
      }
      await Api.wait(100)
      return Promise.resolve(true)
    },
    set(campo, valor) {
      this.equipo[campo] = valor
      console.log("Set", campo, valor)
    },
    async setModo(val) {
      this.modo = val
      console.log("setModo", val)
      if (val == 'custodia') {
        this.custodias = (await Api.find('custodia', ['idEquipo,eq,' + this.id], {
            subset: [{
              coleccion: 'directorio',
              alias: 'autor',
              query: '_id,eq,',
              sustituir: 'idAutor',
              unico: true
            }]
          }))
          .sort((a, b) => a.fecha < b.fecha ? 1 : -1)
        console.log("Custodia", this.custodias)
      }
      if (val == 'historial') {
        this.historialServicios = (await Api.find('ordenservicio', ['idEquipo,eq,' + this.id], {
          subset: [{
            coleccion: 'cliente',
            query: '_id,eq,',
            sustituir: 'idCliente',
            unico: true
          }],
          sort: ['fecha,-1'],
          //limit:10
        }))
      }
    },
    async subirImagen() {
      this.cargando = true
      try {
        let imagen = await Api.upload('#img')
        if (!this.equipo.imagenes)
          this.equipo.imagenes = []
        let descripcion = prompt('Descripción de la imagen (opcional)', 'Imagen ' + (this.equipo.imagenes.length + 1))
        this.equipo.imagenes.push({
          imagen,
          descripcion
        })
      } catch (e) {
        console.error("EIMAGEN", e)
        toast("No se pudo subir la imagen")
      }
      this.cargando = false
    },
    async guardar() {
      if (!this.equipo.idAutor)
        this.equipo.idAutor = this.yo.id
      this.equipo.fechaModificacion = this.$options.filters.moment(new Date(), 'YYYY-MM-DD')
      let u = await Api.save('equipo', this.equipo)
      toast("Guardado")
      if (!this.equipo._id) {
        this.equipo._id = u._id
        this.guardarCustodia()
      }
      await Api.wait()
      if (!this.esModal) {
        this.$router.push('/catalogos/equipos')
      } else {
        Api.$emit('nuevoEquipoCreado', u)
      }
    },
    inicializarFormCustodia() {
      this.formCustodia = {
        idEquipo: '',
        tipoCustodia: this.custodias.length == 0 ? 'Alta' : 'Cliente',
        idAutor: (Api.fetchLocal('cmms.yo') || {})._id,
        fecha: new Date().getTime(),
        notas: ''
      }
    },
    async guardarCustodia() {
      this.formCustodia.idEquipo = this.equipo._id
      await Api.save('custodia', this.formCustodia)
      toast("Custodia cambiada")
      await Api.wait(1000)
      window.location.reload()
    },
    cerrarModal() {
      Api.$emit('cerrarModal', true)
    },
    async seleccionarCliente() {
      let vm = this
      let id = 'seleccionarCliente' + Math.random()
      console.log("ModalSeleccionarCliente")
      return this.$ionic.modalController
        .create({
          component: ModalSeleccionarCliente,
          swipeToClose: true,
          componentProps: {
            parent: vm,
            propsData: {
              clientes: vm.clientes,
              mostrarItemTodos: false
            }
          }
        })
        .then(m => {
          vm.modals[id] = m
          console.log("ModalSeleccionarCliente", vm.modals[id])
          vm.modals[id].present()
          vm.modals[id].onDidDismiss(_ => {
            console.log("seleccionarCliente Modal cerrado")
            Api.$off('ModalSeleccionarClienteCerrar')
            Api.$off('seleccionarCliente')
          })
          Api.$on('ModalSeleccionarClienteCerrar', _ => {
            console.log("$on ModalSeleccionarClienteCerrar")
            vm.modals[id].dismiss()
          })
          Api.$on('seleccionarCliente', c => {
            console.log("$on seleccionarCliente", c)
            vm.equipo.idCliente = c._id
            toast("Cliente seleccionado: " + (c.alias || c.nombre))
            vm.$forceUpdate()
            vm.modals[id].dismiss()
          })
        })
    },
    async seleccionarTipo() {
      let vm = this
      let id = 'seleccionarTipo' + Math.random()
      console.log("ModalSeleccionarTipoEquipo")
      return this.$ionic.modalController
        .create({
          component: ModalSeleccionarTipoEquipo,
          swipeToClose: true,
          componentProps: {
            parent: vm,
            propsData: {
              //clientes
            }
          }
        })
        .then(m => {
          vm.modals[id] = m
          console.log("ModalSeleccionarTipoEquipo", vm.modals[id])
          vm.modals[id].present()
          vm.modals[id].onDidDismiss(_ => {
            console.log("seleccionarCliente Modal cerrado")
            Api.$off('ModalSeleccionarTipoEquipoCerrar')
            Api.$off('seleccionarTipoEquipo')
          })
          Api.$on('ModalSeleccionarTipoEquipoCerrar', _ => {
            console.log("$on ModalSeleccionarTipoEquipoCerrar")
            vm.modals[id].dismiss()
          })
          Api.$on('seleccionarTipoEquipo', c => {
            console.log("$on seleccionarTipoEquipo", c)
            vm.equipo.tipo = c
            toast("Tipo seleccionado: " + c)
            vm.$forceUpdate()
            vm.modals[id].dismiss()
          })
        })
    }
  },
  async mounted() {
    this.empresa = (await Api.get('empresa'))[0] || {}
    this.clientes = (await Api.get('cliente'))
      .filter(c => c.nombre && c.nombre != '')
      .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
    this.tiposEquipos = await TiposEquipos.obtener()
    this.tiposCustodia = await TiposCustodia.obtener()
    this.marcas = await Marcas.obtener()
    await this.obtener()
    if (this.modo2)
      this.setModo(this.modo2)
    this.inicializarFormCustodia()
    this.bloquearInterfaz = false
  }
}
</script>
